import { render, staticRenderFns } from "./TariffMiniBurn.vue?vue&type=template&id=e31339a2&scoped=true"
import script from "./TariffMiniBurn.vue?vue&type=script&lang=js"
export * from "./TariffMiniBurn.vue?vue&type=script&lang=js"
import style0 from "./TariffMiniBurn.vue?vue&type=style&index=0&id=e31339a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31339a2",
  null
  
)

export default component.exports